import videosApi from '@/services/videosApi'
import playerApi from '@/services/playerApi'
import profileApi from '@/services/profileApi'
import aiworkflowApi from '@/services/aiworkflowApi'

const getVideoConfig = async ({ commit }, video) => {
  try {
    const ret = await videosApi.getAVideo(video)
    commit('UPDATE_VIDEO', ret.data)
  } catch (e) {
    console.error(e)
  }
}

const getVideoProfileId = async ({ commit }, profile) => {
  try {
    const ret = await profileApi.getProfileId(profile)
    const smartSearch = ret.data.general?.smartSearch ?? false
    commit('UPDATE_SMART_SEARCH', smartSearch)
    commit('UPDATE_VIDEO_PROFILE', ret.data)
  } catch (e) {
    console.error(e)
  }
}

const createProfile = async ({ commit }, videoId) => {
  try {
    const ret = await profileApi.createProfile(videoId)
    commit('UPDATE_VIDEO_PROFILE_ID', ret.data.id)
    return ret
  } catch (e) {
    console.log(e)
  }
}

const setProfileToVideos = async (_, data) => {
  try {
    await profileApi.setProfileToVideos(data[0], [data[1]])
  } catch (e) {
    console.log(e)
  }
}

const updateProfile = async ({ commit }, config) => {
  try {
    const ret = await profileApi.updateProfile(config[0], config[1])
    commit('UPDATE_VIDEO_PROFILE', ret.data)
  } catch (e) {
    commit('UPDATE_STATUS_ERROR', true)
    console.error(e)
  }
}

const updateChapter = async ({ commit }, config) => {
  try {
    await playerApi.updateVideoCurrentConfig(config[0], config[1])
  } catch (e) {
    commit('UPDATE_STATUS_ERROR', true)
    console.error(e)
  }
}

const updateCta = async ({ commit }, config) => {
  try {
    await playerApi.updateVideoCurrentConfig(config[0], undefined, config[1])
  } catch (e) {
    commit('UPDATE_STATUS_ERROR', true)
    console.error(e)
  }
}

const updateOutsideCta = async ({ commit }, config) => {
  try {
    await playerApi.updateVideoCurrentConfig(
      config[0],
      undefined,
      undefined,
      config[1]
    )
  } catch (e) {
    commit('UPDATE_STATUS_ERROR', true)
    console.error(e)
  }
}

const getVideoPlayer = async ({ commit }) => {
  try {
    const ret = await playerApi.getPlayer()
    commit('UPDATE_PLAYER', ret.data)
  } catch (e) {
    console.error(e)
  }
}

const fetchSubtitles = async ({ commit }, { libraryId, videoId }) => {
  try {
    const data = await videosApi.getVideoConfig(libraryId, videoId)
    commit('UPDATE_VIDEO_SUBTITLES', data.subtitles || [])
  } catch (e) {
    console.error(e)
  }
}

const aiWorkFlowStatus = async ({ commit }, videoId) => {
  try {
    const { data: aiWorkflowData } = await aiworkflowApi.getAiWorkflow(videoId)
    if (aiWorkflowData.length) {
      const status = aiWorkflowData
        .filter((objeto) =>
          ['QUESTIONS', 'MINDMAP', 'ABSTRACT'].includes(objeto.type)
        )
        .map((objeto) => ({
          status: objeto.status,
          type: objeto.type,
          id: objeto.id,
          created_at: objeto.created_at,
        }))

      if (status.length) {
        commit('UPDATE_AI_WORKFLOW_STATUS', status)
        return status
      }
      return false
    } else {
      return false
    }
  } catch (error) {
    return error
  }
}
const handleFetchAiWorkFlowData = async (
  { commit },
  { pullzone_name, video_external_id }
) => {
  try {
    const data = await aiworkflowApi.getAiWorkFlowData(
      pullzone_name,
      video_external_id
    )

    commit('UPDATE_AI_WORKFLOW_DATA', data)
    return data
  } catch (error) {
    return error
  }
}

export {
  getVideoConfig,
  getVideoProfileId,
  setProfileToVideos,
  updateProfile,
  getVideoPlayer,
  updateChapter,
  createProfile,
  updateCta,
  updateOutsideCta,
  fetchSubtitles,
  aiWorkFlowStatus,
  handleFetchAiWorkFlowData,
}
